import moment from 'moment';

class DateHelper {
    public static toUTCTimestamp = (input: Date) => {
        const seconds = input.getTime();
        const output = Math.floor(seconds / 1000);

        return output;
    };

    public static fromUTCTimestamp = (input: number | string) => {
        let output: Date;
        if (typeof input === 'string') {
            output = new Date(input);
        } else {
            const seconds = input * 1000;
            output = new Date(seconds);
        }

        return output;
    };

    public static fromUTCDateTimeToLocalDate(dateString: string, format: string) {
        const utcDate = moment(dateString, 'YYYY-MM-DDTHH:mm:ss').utc(true);
        return moment.utc(utcDate).local().format(format);
    }

    public static formatDate(value: Date) {
        if (!value) {
            return '';
        }
        return value.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    public static formatDateTime(value: Date): string {
        if (!value) {
            return '';
        }

        // Function to add leading zeros to numbers less than 10
        const pad = (num: number): string => num < 10 ? `0${num}` : num.toString();

        // Extracting components of the date
        const year = value.getFullYear();
        const month = pad(value.getMonth() + 1); // getMonth() is zero-based
        const day = pad(value.getDate());
        const hour = pad(value.getHours());
        const minute = pad(value.getMinutes());
        const second = pad(value.getSeconds());

        // Constructing the format "YYYY-MM-DD HH:MM:SS"
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }

    /**
     * Constructing date format //Day, Month, Date, Time/ Sun, Sep 15, 15:00
     * @param Date 
     * @returns DateString Sun, Sep 15, 15:00
     */
    public static scheduleDateFormat(value: Date): string {
        if (!value) {
            return '';
        }
    
        // Using toLocaleString() to format the date
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'short',  // "Sun"
            month: 'short',    // "Sep"
            day: 'numeric',    // "15"
            hour: 'numeric',   // "15"
            minute: '2-digit', // "00"
            hour12: false      // 24-hour format (removes AM/PM)
        };
    
        return value.toLocaleString('en-US', options);
        
    }    

     /**
     * Extract time (hours, minutes, seconds) from a date string in the format "MM/DD/YYYY HH:mm:ss"
     * @param dateString - The date string in the format "MM/DD/YYYY HH:mm:ss"
     * @returns An object containing hours, minutes, and seconds
     */
    public static extractScheduleTime(dateString: string): { hours: string, minutes: string, seconds: string } {
        const date = new Date(dateString);
        
        if (isNaN(date.getTime())) {
           // throw new Error('Invalid date format');
        }
        
        const hours = date.getHours().toString().padStart(2, '0');;
        const minutes = date.getMinutes().toString().padStart(2, '0');;
        const seconds = date.getSeconds().toString().padStart(2, '0');;

        return { hours, minutes, seconds };
    }

    public static extractScheduleFields = (start: string, end: string) => {
        const startDateTime = new Date(start);
        const endDateTime = new Date(end);

        const formatDate = (date: Date) =>
            `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date
                .getDate()
                .toString()
                .padStart(2, '0')}/${date.getFullYear()}`;

        const scheduleStartTimeDate = formatDate(startDateTime); // MM/DD/YYYY
        const scheduleStartTimeString = startDateTime.toTimeString().split(' ')[0]; // HH:mm:ss

        const scheduleEndTimeDate = formatDate(endDateTime); // MM/DD/YYYY
        const scheduleEndTimeString = endDateTime.toTimeString().split(' ')[0]; // HH:mm:ss

        // Calculate schedule hours
        const scheduleHours = (
            (endDateTime.getTime() - startDateTime.getTime()) /
            (1000 * 60 * 60)
        ).toFixed(1); // Hours difference

        return {
            scheduleStartTimeDate,
            scheduleStartTimeString,
            scheduleEndTimeDate,
            scheduleEndTimeString,
            scheduleHours,
        };
    };
}

export default DateHelper;
